import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";
import TitleAndBody from "./title-and-body";
import { connectToProps, _ } from "../../model/utils";
import { fieldChanged } from "../../store/actions";

const leftText = _.notesLeftText.join("\n");
const rightText = _.notesRightText.join("\n");
const rightTablePriorityText = _.notesTablePriorityText.join("\n");

const mapDispatchToProps = dispatch => ({
  fieldChanged: fieldName => dispatch(fieldChanged(fieldName))
});

const Notes = ({ fieldChanged, notes, setNotes, includeReservedTableNote }) => {
  const onChange = React.useCallback(
    ev => {
      setNotes(ev.target.value);
      fieldChanged("notes");
    },
    [setNotes, fieldChanged]
  );

  return (
    <div className="row">
      <div className="col-md-6">
        <TitleAndBody title={_.specialRequests} body={leftText} />
        <textarea styleName="textarea" value={notes} onChange={onChange} />
      </div>
      <div className="col-md-6">
        <TitleAndBody
          title={_.conditions}
          body={
            rightText + (includeReservedTableNote ? rightTablePriorityText : "")
          }
        />
      </div>
    </div>
  );
};

Notes.propTypes = {
  fieldChanged: PropTypes.func.isRequired,
  notes: PropTypes.string,
  setNotes: PropTypes.func.isRequired,
  includeReservedTableNote: PropTypes.bool
};

export default connectToProps(["notes"], () => ({}), mapDispatchToProps)(Notes);
